import doctors from '../partials/doctors';
import gallery from '../partials/gallery';

export default {
    init() {
        doctors();
        gallery();
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js